import React, { FC, useEffect } from 'react';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../hooks/redux';
import {
	setActivationModalOpen,
	setLoginModalOpen,
} from '../../../redux/reducers/ui/modalsReducer';
import Loader from '../../Simple/Loader/Loader';
import PATHS from '../../../lib/consts/paths';
import useUserMeQuery from '../../../reactQuery/hooks/useUserMeQuery';

type ProtectedRouteProps = {
	redirectPath: string;
	element: React.ReactElement<any>;
	disableRedirect?: boolean;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({
	redirectPath = PATHS.homePage,
	element,
	disableRedirect,
}) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const currentLocation = useLocation();

	const data: any = useUserMeQuery();

	useEffect(() => {
		if (data.status === 'loading') return;
		if (!data || !data.data || !data?.data.isActive || data.isError) {
			if (data.data && !data.data.isActive) {
				dispatch(setActivationModalOpen(true));
			} else {
				dispatch(setLoginModalOpen(true));
			}
			navigate(redirectPath);
		} else if (data.data) {
			const matches = matchRoutes(
				[{ path: `${PATHS.userProfile.root}/${PATHS.userProfile.params.profile}` }],
				currentLocation,
			);
			if (!data.data.subscriptionPlanId && !matches && !disableRedirect) {
				navigate(PATHS.plans);
			}
		}
	}, [data.isFetching, data.data, data.error, currentLocation]);

	if (data.isFetching) return <Loader />;

	if (data && data.data && !data.data.isActive) return <Loader />;

	return element;
};

export default ProtectedRoute;
